// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2g2jN","header":"PatientBlock_header__3MKr-","label":"PatientBlock_label__2Dycw","option":"PatientBlock_option__zEWqR"};